import { FirewallAdvancedRuleFormValue } from '@nirvana/shared/dtos/types/policies/common';
import { FirewallAdvancedRuleFormValueWithAdditionalFrontendFields } from '../gridComponents/GzFirewallAdvancedRulesGridDataProvider';

export function getSanitizedItemWithoutAdditionalFrontendFields(
  gridItem: FirewallAdvancedRuleFormValueWithAdditionalFrontendFields
): FirewallAdvancedRuleFormValue {
  const {
    name,
    status,
    network,
    protocol,
    setPermission,
    localIp,
    localPort,
    remoteIp,
    remotePort,
    direction,
    mac,
    ...sanitizedItem
  } = gridItem;

  return sanitizedItem;
}
